export const AddIcon = () => {
  return <span className="material-symbols-outlined">add</span>;
};
